import props from '../layoutProps';
import image from '../../../../../static/learning-secondary@large.jpg';

const key = 'secondary-school';

export default {
  ...props,
  rootNavKey: [...props.rootNavKey, key],
  parentKeys: [...props.parentKeys, key],
  image,
};
